// extracted by mini-css-extract-plugin
export var container = "_6b-0";
export var infoButton = "_6b-1";
export var label = "_6b-3";
export var labelExpanded = "_6b-4";
export var price = "_6b-5";
export var priceExpanded = "_6b-6";
export var title = "_6b-2";